import { connect } from "react-redux";
import styles from './index.module.scss';

function FormField({children, title, icon, required, isError } : { children: any, title?: string, icon?: string, required?: boolean, isError?: boolean }) {

  return <div className="form-group">
    <label>{title}</label>
    <div className={`p-inputgroup`}>
      {icon && <span className={`p-inputgroup-addon`}><i className={icon} /></span>}
      {required && <span className={`p-inputgroup-addon ${(isError && styles.erroraddon) ?? ''}`}><i className="pi pi-exclamation-circle" /></span>}
      {children}
    </div>
  </div>
}


export default connect((s:any) => ({ storage:s.main }))(FormField);